// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-password[data-v-5e1c935f]{\n  width: 300px;\n}\n.modify-password[data-v-5e1c935f]{\n    /* margin: 0 10px 0 50px; */\n}\n.dialog-footer[data-v-5e1c935f]{\n  text-align: right;\n}\n.pos-withdraw-lock-tip[data-v-5e1c935f] {\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border: 1px solid #faecd8;\n  border-radius: 4px;\n  background: #fdf6ec;\n  color: #e6a23c;\n  font-size: 13px;\n  line-height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
